import { useEffect, useRef } from "react";

const trenutki = [
  { icon: "ri-sun-line", label: "Jutranja kava" },
  { icon: "ri-leaf-line", label: "Popoldanski oddih" },
  { icon: "ri-moon-line", label: "Večerni pogovor" },
];

export default function Gather() {
  const imageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = imageRef.current;
    if (!element) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let frame = 0;

    const update = () => {
      frame = 0;
      const rect = element.getBoundingClientRect();
      const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      const shift = Math.max(Math.min(progress * -60, 60), -60);
      element.style.transform = `translate3d(0, ${shift}px, 0) scale(1.12)`;
    };

    const handleScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div ref={imageRef} className="absolute inset-0 h-full w-full will-change-transform">
        <div className="h-full w-full bg-gradient-to-br from-primary-950 via-primary-900 to-primary-950" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/75 via-primary-950/45 to-primary-950/80" />

      <div className="pointer-events-none absolute inset-5 z-[2] hidden border border-background-50/10 md:block" />

      <div className="relative z-10 flex min-h-[460px] w-full items-center justify-center px-5 py-20 md:min-h-[580px] md:py-24">
        <div className="reveal-soft mx-auto max-w-[780px] text-center">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full border border-accent-400/50 text-accent-300">
            <i className="ri-heart-3-line text-lg" />
          </span>

          <div className="mt-6 flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-accent-400/40" />
            <span className="eyebrow text-accent-300">Trenutki za vas</span>
            <span className="h-px w-8 bg-accent-400/40" />
          </div>

          <h2 className="mt-5 font-heading text-[31px] leading-[1.14] text-background-50 sm:text-[42px] lg:text-[56px]">
            Dobri trenutki se
            <span className="block italic text-accent-300">začnejo tukaj.</span>
          </h2>

          <p className="mx-auto mt-6 max-w-[460px] text-[14px] leading-relaxed text-background-100/85 md:text-[15px]">
            Za jutranji začetek, popoldanski oddih in prijetno družbo.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-3 gap-y-2.5 sm:gap-x-4">
            {trenutki.map((item) => (
              <span
                key={item.label}
                className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/[0.06] px-4 py-2 font-label text-[10px] font-semibold uppercase tracking-[0.14em] text-background-100/85 backdrop-blur-sm"
              >
                <i className={`${item.icon} text-[13px] text-accent-300`} />
                {item.label}
              </span>
            ))}
          </div>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <a
              href="#kontakt"
              className="btn-base w-full border-background-50/50 text-background-50 hover:border-accent-500 hover:bg-accent-500 hover:text-primary-950 sm:w-auto"
            >
              Obiščite nas
              <i className="ri-arrow-right-line text-base" />
            </a>
            <a
              href="#ponudba"
              className="group inline-flex w-full items-center justify-center gap-2 py-2 font-label text-[10px] font-semibold uppercase tracking-[0.18em] text-background-100/70 transition-colors hover:text-accent-300 sm:w-auto"
            >
              Poglejte ponudbo
              <span className="h-px w-6 bg-background-100/40 transition-all duration-500 group-hover:w-9 group-hover:bg-accent-300" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}